import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';

@Component({
  selector: 'app-trade-in-reset-confirm-dialog',
  templateUrl: './trade-in-reset-confirm-dialog.component.html',
  styleUrl: './trade-in-reset-confirm-dialog.component.scss',
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, IceButtonComponent],
})
export class TradeInResetConfirmDialogComponent {
  private dialogRef = inject<MatDialogRef<TradeInResetConfirmDialogComponent, boolean>>(MatDialogRef);

  confirmReset(): void {
    this.dialogRef.close(true);
  }

  abort(): void {
    this.dialogRef.close(false);
  }
}
